exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0}.magnify{margin:50px auto;position:relative}.large{width:175px;height:175px;position:absolute;border-radius:100%;box-shadow:0 0 0 7px hsla(0,0%,100%,.85),0 0 7px 7px rgba(0,0,0,.25),inset 0 0 40px 2px rgba(0,0,0,.25);background:url(\"http://thecodeplayer.com/uploads/media/iphone.jpg\") no-repeat;display:none}.small{display:block}h2{color:#fff;background-color:#b30a23}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/planos/planos.css
// module id = 247
// module chunks = 0